import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiConfigService } from 'src/app/core/services/api-config/api-config.service';
import {
  ChangePassFormType,
  ForgotPswResetType,
  ForgotPswSendCodeType,
  ForgotPswVerifyCodeType,
  LoginForCodeType,
  LoginResultType,
  LoginType,
  RefreshTokenType,
  RegisterFormType,
} from 'src/app/shared/types/auth.types';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private ApiConfigService: ApiConfigService
  ) {}

  private get baseUrl(): string {
    return `${this.ApiConfigService.apiUrl}/account`;
  }

  login(body: LoginForCodeType): Observable<{ data: any }> {
    return this.http.post<{ data: any }>(`${this.baseUrl}/login`, body);
  }

  loginConfirm(body: LoginType): Observable<LoginResultType> {
    return this.http
      .post<LoginResultType>(`${this.baseUrl}/login-confirm`, body)
      .pipe(map((response) => response));
  }

  logout() {
    return this.http.post(`${this.baseUrl}/logout`, {});
  }

  refreshToken(body: RefreshTokenType): Observable<LoginResultType> {
    return this.http
      .post<LoginResultType>(`${this.baseUrl}/refresh-token`, body)
      .pipe(map((response) => response));
  }

  createAccount(body: RegisterFormType): Observable<{ data: any }> {
    return this.http.post<{ data: any }>(`${this.baseUrl}/activation`, body);
  }

  changePass(body: ChangePassFormType): Observable<{ data: any }> {
    return this.http.post<{ data: any }>(
      `${this.baseUrl}/change-password`,
      body
    );
  }

  forgotPswSendCode(body: ForgotPswSendCodeType): Observable<{ data: any }> {
    return this.http.post<{ data: any }>(
      `${this.baseUrl}/forgot-password/send-code`,
      body
    );
  }

  forgotPswVerifyCode(
    body: ForgotPswVerifyCodeType
  ): Observable<{ data: any }> {
    return this.http.post<{ data: any }>(
      `${this.baseUrl}/forgot-password/verify-code`,
      body
    );
  }

  forgotPswReset(body: ForgotPswResetType): Observable<{ data: any }> {
    return this.http.post<{ data: any }>(
      `${this.baseUrl}/forgot-password/reset`,
      body
    );
  }
}
